module.exports = __webpack_public_path__ + "img/Home3m.73b0db28.png";